<template>
  <div>
    <CSFAdd />
  </div>
</template>

<script>
import CSFAdd from "./CSFAdd.vue";

export default {
  components: {
    CSFAdd,
  },

  data() {
    return {};
  },
};
</script>
